import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../authentication.service';
import { LicenseService } from '../licens.service';
import { LicenseData } from 'src/app/models/LicenseData';
import { environment } from 'src/environments/environment';
import { version } from 'src/environments/version.prod';

@Component({
  selector: 'headband',
  templateUrl: 'headband.component.html',
  styleUrls: ['./headband.component.less', './../common.less'],
})

export class HeadbandComponent implements OnInit {
  @Input() maxVoters: number = 0;
  @Input() accountName: string = "";
  @Input() hasHotline: boolean = true;
  @Input() displayHotline: boolean = true;
  @Output() hotlinePopupChange = new EventEmitter<boolean>();
  @Output() optionsPopupChange = new EventEmitter<boolean>();
  @Output() buyPopupEvent = new EventEmitter<boolean>();
  licenseTime: string;
  eventCounter = 0;
  licencesReady: boolean = false;
  isAssoc: boolean;
  clientType = 'assoc';
  stripeConstants = environment.stripeConstants;
  stripe: stripe.Stripe;
  version = version;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private licenseService: LicenseService,
  ) { }

  goToPoll() {
    this.router.navigate(['/polls']);
  }

  goToProfile() {
    this.router.navigate(['/profile']);
  }

  buyOfferPopup() {
    this.buyPopupEvent.emit(true);
  }

  triggerHotlinePopup() {
    this.hotlinePopupChange.emit(true);
  }

  changeSubscription() {
    this.optionsPopupChange.emit(true);
  }

  triggerPopup() {
    this.hotlinePopupChange.emit(true);
    this.optionsPopupChange.emit(true);
  }

  logout() {
    this.authenticationService.logout();
    this.router.navigate(['/connexion']);
  }

  ngOnInit() {
    this.licenseService.license.subscribe((res: LicenseData) => {
      this.licencesReady = true;

      this.hasHotline = res.hasHotline;
      this.maxVoters = res.votes;
      this.eventCounter = res.events;
      if (res.client !== null) { this.isAssoc = !(res.client !== 'corp'); }
      this.clientType = res.client;
      switch (res.duration) {
        case "Y": {
          this.licenseTime = "Y";
          break;
        }
        case "DM": {
          this.licenseTime = "DM";
          break;
        }
        default:
          this.licenseTime = "D";
      }
      this.accountName = this.authenticationService.getUserData();
    });
    this.stripe = Stripe(this.stripeConstants.key);
  }
}
